<template>
    <!--搜索框的下拉属性结构-->
    <div class="warp-tree" :style='{width:width+"px"}'>
         <Treeselect v-model="val"  :multiple="false" :options="options" :clearable="false" :normalizer="normalizer" @select="selectBtn" :show-count="true" :placeholder="placeholder" />
    </div>
</template>
<script>
 export default{
    data:()=>({
         val:null
    }),
    props:{
        keyVal:{
            type: String,
            default: "keyVal",  
        },
        width:{
          type: String,
          default: "200",  
        },
        placeholder:{
            type: String,
            default: "选择上级目录",
        },
        keyId:{
            type: String,
            default: "id", 
        },
        labelKey:{
            type: String,
            default: "name", 
        },
        childKey:{
            type: String,
            default: "",  
        },
        options:{
            type:Array,
        }
    },
    created(){

    },
    mounted(){
       
    },
    methods:{
        /** 转换菜单数据结构 */
        normalizer(node) {
            if (node[this.childKey] && !node[this.childKey].length) {
                delete node[this.childKey];
            }
            return {
                id: node[this.keyId],
                label: node[this.labelKey],
                children: node[this.childKey]
            }
       },
       // 获取选中的值
       selectBtn(ev){
           let parms = {
               key:this.keyVal,
               val:ev,
           }
           this.$emit('getVal',parms);
       },
       //设定选中的值
       setVal(ev){
          this.val = ev
       },
    }
 }
</script>
<style lang="scss" scoped>
     .warp-tree{
         ::v-deep .vue-treeselect__input{
            position: relative;
            font-size: 14px!important;
            height: 30px !important; 
         }
     }
::v-deep .vue-treeselect{
    height: 32px !important; 
} 

::v-deep .vue-treeselect__control {
  display: inline-block;
  border: 1px solid #DCDFE6!important;
  height: 33px !important; 
}

::v-deep .vue-treeselect__single-value {
  line-height:29px !important;
  font-size: 14px;
  color: #606266!important;
}
::v-deep .vue-treeselect__placeholder {
  line-height: 31px !important;
  font-size: 14px;
  color: #CCD0D6!important;
}
::v-deep .vue-treeselect__control-arrow-container{
   font-size: 14px!important;
   position: relative;
   right: 4px;
}
::v-deep .vue-treeselect__label{
    font-size: 14px!important;
    color: #606266!important;
}
</style>